import { ConfirmationModal } from './ConfirmationModal'

export { ConfirmationModal }
